import { COUNTRIES } from 'baseui/phone-input';

export const getCountryByDialCode = (dialCode: string) => {
  return (
    Object?.values(COUNTRIES)?.find((item) => item?.dialCode === dialCode) ||
    COUNTRIES.ID
  );
};
